// 2020-06-27export { CorralFiltroComponent } from './corral-filtro.component';